import React from "react";
import { HashLink } from "react-router-hash-link";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const RootCanalTherapy = () => {
  const { t, i18n } = useTranslation();
  const content = t("RootCanalTherapy.page", { returnObjects: true });
  const seo = t("RootCanalTherapy.seo", { returnObjects: true });

  return (
    <div
      className="container py-5 mt-5"
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
    >
      <Helmet>
        <link rel="canonical" href="https://saleemsmile.com/articles/root-canal" />

        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />

        <meta property="og:title" content={seo.ogTitle} />
        <meta property="og:description" content={seo.ogDescription} />
        <meta property="og:type" content="article" />
        <meta
          property="og:image"
          content="https://slimsmile.ps/images/root-canal.jpg"
        />
        <meta
          property="og:url"
          content="https://slimsmile.ps/articles/root-canal-therapy"
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: content.faq.map((item) => ({
              "@type": "Question",
              name: item.q,
              acceptedAnswer: {
                "@type": "Answer",
                text: item.a,
              },
            })),
          })}
        </script>
      </Helmet>

      <h1 className="mb-4 text-center" style={{ color: "#00b3ff" }}>
        {content.title}
      </h1>
      <h5 className="text-center mb-3">{content.subtitle}</h5>
      <p className="text-center text-muted">{content.author}</p>
      <p className="text-center text-muted">{content.center}</p>

      <h2 className="mt-4">{content.whatTitle}</h2>
      <p>{content.whatP1}</p>
      <p>{content.whatP2}</p>

      <h2 className="mt-4">{content.whenTitle}</h2>
      <ul>
        {content.whenList.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{content.stepsTitle}</h2>
      <ol>
        {content.stepsList.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ol>

      <h2 className="mt-4">{content.durationTitle}</h2>
      <ul>
        {content.durationList.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{content.advantagesTitle}</h2>
      <ul>
        {content.advantagesList.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{content.messageTitle}</h2>
      <p>
        <em>{content.messageText}</em>
      </p>

      <footer className="mt-4">
        <HashLink to="/#services" className="btn btn-outline-secondary">
          {content.back}
        </HashLink>
      </footer>
    </div>
  );
};

export default RootCanalTherapy;
